import { NewsLetterHeader } from '@arvesta-websites/icons';

import type { Config } from '../default-config';
import mergeConfig from '../merge-config';

const config: Config = mergeConfig({
  NewsletterHeader: {
    SVG: NewsLetterHeader.AveveAgrarisch,
    className: 'newsletter-svg',
  },
  breadcrumb: {
    display: true,
  },
  button: {
    ctaBanner: {
      image: 'primary',
      text: 'primary',
    },
    duoBanner: 'primary',
    infoSection: 'primary',
    shortBanner: 'primary',
  },
  footer: {
    byArvesta: false,
    version: 'V2',
  },
  header: {
    height: '50px',
  },
});

export default config;
